export const sendLogToRecommender = (data) => {
  if (typeof window !== "undefined" && window.sendLogToRecommender) {
    window.sendLogToRecommender(data)
  }
}
